import { AppConstants } from "@/common";
import type { PublisherAppConfig } from "@/common/types/app-config";
const { shelfKeys }: typeof AppConstants = AppConstants;

const isManualLoginEnabled: boolean = import.meta.env.VITE_ENABLE_MANUAL_LOGIN === "true";

const config: PublisherAppConfig = {
    featureGuestModeEnabled: true,
    featureHeaderEnabled: true,
    featureSplashLogoEnabled: true,
    featureLoginLogoEnabled: true,
    authMethod: {
        featureMacAddressLoginEnabled: false,
        featureRefreshTokenLoginEnabled: false
    },
    signInMethod: {
        oktaEnabled: !isManualLoginEnabled,
        codeEnabled: false,
        formEnabled: isManualLoginEnabled,
    },
    isEnabledServiceLinkHeader: false,
    isTimeFormat12: false,
    linkItems: {
        main: {
            client: ["home", "guide", "myTv", "onDemand", "search", "settings"],
            guest: ["home", "guide", "onDemand", "login", "search", "settings"]
        },
        settings: {
            client: [
                "account",
                "favorites",
                "settingsPlayer",
                "parentControl",
                "language",
                "privacy",
                "help",
                "clearCache"
            ],
            guest: ["account", "language", "privacy", "clearCache"]
        }
    },
    devMode: {
        sections: ["api", "oktaApi"]
    },
    mainPage: "home",
    lineViewRows: {
        home: [
            shelfKeys.trendsCards,
            shelfKeys.recentChannelsCards,
            shelfKeys.olympicsCards,
            shelfKeys.continueWatchingCards,
            shelfKeys.recentlyOnDemandCards,
            shelfKeys.liveSeries,
            shelfKeys.moviesCards,
            shelfKeys.sportsCards,
            shelfKeys.newsCards,
            shelfKeys.kidsCards,
            shelfKeys.watchAgainCards
        ],
        vod: [
            shelfKeys.channelCards,
            shelfKeys.filtersCards,
            shelfKeys.newReleasesCards,
            shelfKeys.mostPopularCards,
            shelfKeys.recommendedShowsCards,
            shelfKeys.recommendedMoviesCards,
            shelfKeys.vodContinueWatchingCards,
            shelfKeys.genresCards,
            shelfKeys.vodWatchAgainCards
        ]
    },
    guideConfig: {
        featureChannelLogoOriginalEnabled: false,
        featureRedirectToGuidefromPlayerEnabled: false,
        isDynamicOpacityChannelLogo: true,
        featureBtnWatchEnabled: false,
        featureGuideRestartBtnsEnabled: false,
        featureGuideFilterEnabled: true,
        featureGuideControlsEnabled: false,
        featureGuideDetailPageEnabled: true,
        featureMoveLeftRightEnabled: true,
        featureStartFocusCanvasEnabled: false,
        featurePrevProgramEnabled: true,
        featureScrollbarEnabled: false,
        channelsPageSize: 6,
        featureUpdateViewportChannelsEnabled: true
    },
    playerConfig: {
        topPanel: {
            isEnabledChannelNumber: true,
            isEnabledChannelImage: true,
            isEnabledCallSign: true,
            isEnabledProgramName: true
        },
        controlsPanel: {
            isEnabledProgramName: false,
            isEnableAutoCloseInfoAfterUpdateProgram: true
        }
    },
    orderBy: {
        getVodInternalContent: "added_at desc"
    },
    login: {
        welcomeScreenEnabled: true
    },
};

export default defineAppConfig({...config})
